import React, { useRef, useState, useEffect } from 'react';
import { Box, Flex, Input } from '@chakra-ui/react';
import { FaSearch, FaUserPlus } from 'react-icons/fa';
import { InputGroup } from '../../components/ui/input-group';
import ButtonBox from '../../components/shared/buttons/ButtonBox';
import { useColorModeValue } from '../../components/ui/color-mode';
import { darkMode, lightMode } from '../../theme/config';
import ContactBox from '../../components/shared/fields/ContactBox';

const SearchBar = ({ searchTerm, onSearchTermChange, onSearch, isSearching, createNewCustomer }) => {
  const [error, setError] = useState('');
  const backgroundColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?\d{7,15}$/;
  const inputRef = useRef();
  const phoneInputRef = useRef();

  const isPhoneInput = /^[+\d]/.test(searchTerm);

  useEffect(() => {
    if (isPhoneInput) {
      phoneInputRef.current?.focus();
    } else {
      inputRef.current?.focus();
    }
  }, [isPhoneInput]);

  const handleSearch = () => {
    setError('');
    if (!emailRegex.test(searchTerm) && !phoneRegex.test(searchTerm)) {
      setError('Please enter a valid email address or phone number.');
      return;
    }

    onSearch();
    if (isPhoneInput) {
      phoneInputRef.current?.blur();
    } else {
      inputRef.current?.blur();
    }
  };

  return (
    <Box p={2}>
      <Flex
        direction={{ base: "column", md: "column", lg: "row" }}
        align={{ base: "stretch", md: "stretch", lg: "center" }}
        gap={2}
      >
        {/* Search input + Search button */}
        <Flex
          direction="row"
          gap={2}
          flex="1"
        >
          <Box flex="1">
            {isPhoneInput ? (
              <ContactBox
                value={searchTerm}
                onChange={(value) => {
                  const e = { target: { value } };
                  onSearchTermChange(e);
                  setError("");
                }}
                ref={phoneInputRef}
              />
            ) : (
              <InputGroup
                startElement={<FaSearch />}
                w="100%"
                backgroundColor={backgroundColor}
                my={4}
              >
                <Input
                  placeholder="Search by Email or Phone..."
                  value={searchTerm}
                  onChange={(e) => {
                    onSearchTermChange(e);
                    setError("");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSearch();
                  }}
                  ref={inputRef}
                />
              </InputGroup>
            )}
            {error && (
              <Box color="red.500" fontSize="sm" mt={1}>
                {error}
              </Box>
            )}
          </Box>

          {/* <Box paddingTop={error ? 4 : 4} flexShrink={0}> */}
          <Box paddingTop={isPhoneInput ? '0' : '4'} textAlign={{ base: "right", md: "auto", lg: "auto" }}>
            <ButtonBox
              name="Search"
              variant="solid"
              colorPalette="blue"
              onClick={handleSearch}
              width={{ base: "100%", md: "auto" }}
            />
          </Box>
        </Flex>

        {/* Create Customer button */}
        <Box
          width={{ base: "100%", md: "100%", lg: "auto" }}
          textAlign="right"
          paddingBottom={error ? { md: 0, lg: 6 } : { base: 6, md: 0, lg: 0 }}
          flexShrink={0}
        >
          <ButtonBox
            name="Create Customer"
            variant="solid"
            colorPalette="blue"
            onClick={createNewCustomer}
            icon={<FaUserPlus />}
            width={{ base: "100%", md: "auto" }}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default SearchBar;
